import { BehaviorSubject } from 'rxjs';
export const getBalanceAccountsStore = () => {
    const getInitialState = () => ({
        balanceAccounts: [],
        isLoadingBalanceAccounts: false
    });
    const balanceAccountsSubject = new BehaviorSubject(getInitialState());
    const subscribe = (callback) => balanceAccountsSubject.subscribe(callback);
    const balanceAccountsFetchSuccess = (balanceAccounts) => balanceAccountsSubject.next({
        balanceAccounts: balanceAccounts.map(balanceAccount => ({
            ...balanceAccount,
            key: balanceAccount.account
        })),
        isLoadingBalanceAccounts: false
    });
    const setIsLoadingBalanceAccounts = (isLoadingBalanceAccounts) => balanceAccountsSubject.next({
        ...balanceAccountsSubject.getValue(),
        isLoadingBalanceAccounts
    });
    const getBalanceAccounts = () => balanceAccountsSubject.getValue().balanceAccounts;
    const reset = () => balanceAccountsSubject.next(getInitialState());
    return {
        getInitialState,
        subscribe,
        balanceAccountsFetchSuccess,
        setIsLoadingBalanceAccounts,
        getBalanceAccounts,
        reset
    };
};
